module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/col_left-03130c5f96ec27569245b31c07115aaa.svg";